import { render, staticRenderFns } from "./role-manage.vue?vue&type=template&id=884eb6ac&scoped=true&"
import script from "./role-manage.vue?vue&type=script&lang=js&"
export * from "./role-manage.vue?vue&type=script&lang=js&"
import style0 from "./role-manage.vue?vue&type=style&index=0&id=884eb6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884eb6ac",
  null
  
)

export default component.exports